import { ArticleHeading2, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles/header.css';
import { Header } from '../../../base/Header';

export interface IGroupsHeaderStoreProps {
  email: string | null;
}

export function GroupsHeader({ email }: IGroupsHeaderStoreProps) {
  return (
    <Header>
      <div className={styles['content']} data-testid="GroupsHeader">
        <ArticleHeading2>Управление подписками</ArticleHeading2>
        <UIText1>{email}</UIText1>
      </div>
    </Header>
  );
}
